module.exports = __webpack_public_path__ + "img/ic-stats.d4edcd9e.svg";